// extracted by mini-css-extract-plugin
module.exports = {"offerDetails":"Web2Page_offerDetails__bt6k7"};